import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { toggleSearchBar } from './dashboard.actions';


export interface State {
    search: {
        collapsed: boolean;
    };
}

export const initialState: State = {
    search: {
        collapsed: false,
    },
};

export const dashboardReducer = createReducer(
    initialState,
    on(toggleSearchBar, (state, { collapsed }) => ({ ...state, search: { ...state.search, collapsed } })),
);


const selector = createFeatureSelector<State>('dashboard');

export const getSearchCollapsed = createSelector(selector, state => state.search.collapsed);
